import React from 'react'
import { flowRight } from 'lodash'
import { useQuery } from '@apollo/client'
import { Prompt, withRouter } from 'react-router-dom'
import { withTranslationCustom } from 'lib/i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import gql from 'graphql-tag'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

/**
 * Prompt user if trying to navigate away from page when saving is in progress.
 */
const SavePrompt = ({ t, location }) => {
    const { data } = useQuery(gql`
        query bosSaving {
            bosSaving @client
        }
    `, { variables: {}, fetchPolicy: fetchPolicy.CACHE_ONLY })
    return (
        <Prompt
            when={data.bosSaving}
            message={prevLocation => {
                // this is a bit hack, but we don't want to trigger this Prompt if url query or hash changes,
                // so we need to do this check because of Prompt API limitations.
                return location.pathname === prevLocation.pathname || t('saveInProgressWarning')
            }}
        />
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
    withTranslationCustom('common'),
)(SavePrompt)
